import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

const TextareaField = forwardRef(
  ({ className, disabled, full, error, ...rest }, ref) => (
    <textarea
      ref={ref}
      className={twMerge(
        'resize-none text-ellipsis rounded-2 border-solid border-neutral-high-500 bg-neutral-high-100 px-4 py-2 text-base text-neutral-low-100',
        'placeholder:text-neutral-high-500 focus:border-primary-300',
        'dark:border-neutral-low-100 dark:bg-neutral-low-300 dark:text-neutral-high-200 placeholder:dark:text-neutral-high-200 focus:dark:border-primary-100',
        full && 'w-full',
        error &&
          'border-error-300 focus:border-error-300 focus:dark:border-error-200',
        disabled &&
          'cursor-not-allowed select-none bg-neutral-high-300 placeholder:text-neutral-high-500 dark:bg-neutral-low-300 placeholder:dark:text-neutral-low-100',
        className
      )}
      disabled={disabled}
      {...rest}
    />
  )
);

TextareaField.displayName = 'TextareaField';

TextareaField.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  full: PropTypes.bool,
  error: PropTypes.bool,
};

export default TextareaField;
